import CollectionPageRouteHandler from '../../../../pages/collections/CollectionPageRouteHandler';
import createCollectionRouteHandler from './CollectionsRouteHandler';

import type { AMKTRoute } from '../../Routes.types';

export default ({ collectionsConfig, enableAetherExperienceFlag }) => {
  const collectionRoutes: AMKTRoute[] = collectionsConfig.links.collections.map((collection) => ({
    exact: true,
    name: 'collectionsScreen',
    path: collection.link.link.href,
    // @ts-expect-error [MC-2850] - TS2554 - Expected 0 arguments, but got 1.
    component: createCollectionRouteHandler({ collectionKey: collection.key }),
  }));

  const aetherCollectionRoute = {
    exact: true,
    name: 'collectionScreen',
    path: '/collections/:collectionName',
    component: CollectionPageRouteHandler,
  };

  return enableAetherExperienceFlag
    ? collectionRoutes.concat(aetherCollectionRoute)
    : collectionRoutes;
};
